import { z } from 'zod';

export const targetAttendeesModalSchema = z.object({
  targetAttendance: z.coerce
    .number({
      invalid_type_error: 'Target attendance must be a number'
    })
    .int()
    .positive('Target attendance must be a positive number')
    .nullable()
    .optional()
});

export type TargetAttendeesModalFormValues = z.infer<typeof targetAttendeesModalSchema>;
